import { Trans, useTranslation } from "react-i18next";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { translateAnimalCategory, translateAnimalCategoryAge } from "../../../../i18n/translateAnimalCategory";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";

interface InfoSplitBatchProps {
  task: ITaskSplitBatch | undefined;
}


export default function InfoSplitBatch({ task: taskSplitBatch }: InfoSplitBatchProps) {
  const { t } = useTranslation();
  const newDestinations = taskSplitBatch?.destinations;
  const destinations = Array.isArray(newDestinations)
    ? newDestinations
    : taskSplitBatch?.destination_batch_initials
      ? [{
        batch_initials: taskSplitBatch.destination_batch_initials,
        type: taskSplitBatch.inventoryBatch_split_type ?? "",
        categories: taskSplitBatch.categories,
        micro_area_route: taskSplitBatch.destination_micro_area_route,
      }]
      : [];

  return (
    <>
      <div >
        <span><Trans i18nKey="taskDetails.onBatch" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AnimalsIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskSplitBatch?.source_batch_initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>


      {destinations.map((destination, destinationIndex) => {
        const isNewBatch = destination.type === "NEW_BATCH" || destination.type === "Novo lote";
        const isExistingBatch = destination.type === "EXISTING_BATCH" || destination.type === "Lote existente";
        const routeInitials = (destination.micro_area_route ?? [])
          .map(route => route.initials)
          .filter(Boolean)
          .join(", ");

        return <section key={`${destination.batch_initials}-${destinationIndex}`} className="splitBatchDestination">
          {(isNewBatch || isExistingBatch) && <div className="containerQuestion">
            <MessageBalloon text={t("messageBalloon.createNewBatch")} pointed />
            <ButtonYesOrNo onlyResult optionSelected={isNewBatch ? "yes" : "no"} />
          </div>}

          {isNewBatch ?
            <MessageBalloon text={t("messageBalloon.newBatchName", { name: destination.batch_initials })} pointed />
            :
            <div>
              <span><Trans i18nKey="taskDetails.toBatch" /></span>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <AnimalsIcon width={30} className="iconInitialTaskInfo" />
                <div className="labelInitialTaskInfo">
                  <span>{destination.batch_initials}</span>
                  <PointIcon width={15} />
                </div>
              </div>
            </div>
          }

          {destination.categories?.map((category, categoryIndex) => {
            const description = "category_description" in category ? category.category_description : undefined;
            const name = description?.name ?? ("name" in category ? category.name : "");
            return <div key={`${"category_id" in category ? category.category_id : description?.id}-${categoryIndex}`}>
              <div className="lot__title--category" style={{ marginTop: 0 }}>{translateAnimalCategory(name, description?.age_description)}</div>
              {description?.age_description && <div className="lot__subtitle--category">{translateAnimalCategoryAge(description.age_description, name)}</div>}
              <CounterInputV2 name={`info-split-batch-qty-${destinationIndex}-${categoryIndex}`} value={Number(category.quantity ?? 0)} disabled />
            </div>;
          })}

          {routeInitials && <MessageBalloon text={t("messageBalloon.routePaddocks", { paddocks: routeInitials })} pointed />}
        </section>;
      })}
    </>
  )
}
